
import React, { Component } from 'react'
import './App.css'

import intro_p1 from './images/intro_pic1.png'
import intro_p2 from './images/intro_pic2.png'

let Intro = () =>
	<div className="intro">
      <blockquote>
      	<p>2015年10月，全球最大水產市場歐盟向台灣發出一張「黃牌」警告，言明若不限期改善各種「非法」、「未報告」或者「不規範」 (Illegal, unreported and unregulated fishing , IUU) 的漁業行為，將改發「紅牌」，把台灣水產品「判決出場」，禁止銷入歐盟。  </p>
        <p>這張「黃牌」狠狠給出了提醒：在二戰後藉美國經援「自由中國」而復興、崛起，甚而被形容為「日不落國」的台灣遠洋漁業，已經走到了非得轉型升級的十字路口。</p>
        <p>在此同時，從上世紀80年代中期起，中國在雄厚的資本、強大的內需和國家政策支持這三駕馬車的拉動下，以「大躍進」態勢加入漁業爭霸的戰局。從國企到民企；從南極到印度洋……不只在捕獲總量上居冠，需要高技術處理的高價水產品產值排名也直追先進大國。  </p>
        <p>但相對於遠洋漁業的高歌猛進，「近海無魚」的窘況困擾著中國。炸魚、電魚、下毒或者使用流刺網，種種不規範的行徑剝奪了漁業「永續發展」的可能性。而中國對近海漁業資源「海盜式捕撈」的行徑，近年移植到了西非沿海。引發了非洲諸國及區域漁業組織的高度關注。</p>
        <p>兩岸發展遠洋漁業的模式類似，因此不管是國際捕撈配額削減、撈捕規範趨於嚴格，乃至於消費者保育意識抬頭等，這些搶先30年發展的台灣如今被迫面對的難題，中國在不久的將來恐怕同樣繞不開。</p>
        <p>古人說「靠山吃山，靠海吃海」，但時至今日，當「靠海」愈來愈「吃不了海」的時候，我們還能期待年年有「魚」嗎？這是端傳媒推出這個系列專題時，最深沉的一句提問。</p>
      </blockquote>
      <div className="js-gallery-content">
        <img src={intro_p1} />
        <img src={intro_p2} />
        <figcaption className="white">繪：曾立宇/端傳媒</figcaption>
      </div>
    </div>

export default Intro
	


/** WEBPACK FOOTER **
 ** ./src/Intro.js
 **/